// src/Components/Drawer/CustomDrawer/DrawerAlerts.js

import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

export default function DrawerAlerts({
  isSaving,
  alert,
  showUnsavedAlert,
  unsavedMessage,
  onCancelClose,
  onConfirmClose,
  showDeleteConfirm,
  activeTab,
  onCancelDelete,
  onConfirmDelete,
}) {
  const getDeleteMessage = (tab) => {
    switch (tab) {
      case 'MARKERS':
        return 'Are you sure you want to delete this marker?';
      case 'POLYGON':
        return 'Are you sure you want to delete this polygon?';
      case 'POLYLINE':
        return 'Are you sure you want to delete this polyline?';
      default:
        return 'Do you want to clear the info fields?';
    }
  };

  return (
    <>
      {/* Saving Spinner Overlay */}
      <Backdrop
        sx={{
          color: '#00B0FF',
          zIndex: 100002, // AMENDED: Elevated to match global processing overlay tier
          position: 'fixed',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        }}
        open={isSaving}>
        <CircularProgress color='inherit' />
      </Backdrop>

      {/* 1. General Alert (Success/Error messages) */}
      <ConfirmDialog
        open={alert.visible}
        message={alert.message}
        severity={alert.severity}
        sx={{ zIndex: 100005 }} // AMENDED: Elevated to prevent default MUI 1300 trapping
        // No buttons needed for auto-closing alerts
      />

      {/* 2. Unsaved Changes Alert */}
      <ConfirmDialog
        open={showUnsavedAlert}
        onClose={onCancelClose} // Red Cross
        onConfirm={onConfirmClose} // Green Tick
        message={unsavedMessage}
        severity='warning'
        sx={{ zIndex: 100005 }} // AMENDED: Elevated to prevent default MUI 1300 trapping
      />

      {/* 3. Delete Confirmation Alert */}
      <ConfirmDialog
        open={showDeleteConfirm}
        onClose={onCancelDelete} // Red Cross
        onConfirm={onConfirmDelete} // Green Tick
        message={getDeleteMessage(activeTab)}
        severity='warning'
        sx={{ zIndex: 100005 }} // AMENDED: Elevated to prevent default MUI 1300 trapping
      />
    </>
  );
}
